import Vue from "vue";
import store from "@/store";
import settings from "@/settings";

// you can set in settings.js
// errorLog:'production' | ['production', 'development']
// const { errorLog: needErrorLog } = settings
const errors = [];
const getTimestamp = () => {
  return new Date();
};
Vue.config.warnHandler = function(msg, vm, trace) {
  // `trace` 是组件的继承关系追踪
  // console.warn("抛出全局警告");
  // console.warn("warn", msg, vm, trace);
  // console.warn( msg,)
  // console.warn(vm)
  // console.warn(trace)
  // 逻辑处理
};
// window.onerror = (message, source, lineno, colno, error) => {
// 	console.log()
//   // errors.push({time: getTimestamp(), content: error.stack})
// }

// window.addEventListener('error', event => {
//   // errors.push({time: getTimestamp(), content: event.error.stack})
// })
Vue.config.errorHandler = function(err, vm, info, a) {
  // Don't ask me why I use Vue.nextTick, it just a hack.
  // detail see https://forum.vuejs.org/t/dispatch-in-vue-config-errorhandler-has-some-problem/23500
  console.error("抛出全局异常");
  Vue.nextTick(() => {
    store.dispatch("errorLog/addErrorLog", {
      err,
      vm,
      info,
      url: window.location.href
    });
    console.error("抛出全局异常");
    if (err) {
      console.error(err, vm, info);
    }

    if (window.location.href) {
      console.error("访问路径:" + window.location.href);
    }
  });
};
// Vue.config.errorHandler = (err, vm, info, a) => {
// 	console.error("抛出全局异常");
// 	console.error(err);
// 	console.error(vm)
// 	console.error(info)
//   // Don't ask me why I use Vue.nextTick, it just a hack.
//   // detail see https://forum.vuejs.org/t/dispatch-in-vue-config-errorhandler-has-some-problem/23500
//   Vue.nextTick(() => {
//     store.dispatch("errorLog/addErrorLog", {
//       err,
//       vm,
//       info,
//       url: window.location.href
//     });
//     console.error("抛出全局异常");
//     console.error(err);
//     console.error(vm)
//     console.error(info)
//     console.error('访问路径:' + window.location.href)
//   });
// };
// Vue.config.errorHandler = errorHandler;
// Vue.prototype.$throw = (error)=> errorHandler(error,this);
